import { render, staticRenderFns } from "./InviteListImportSettings.vue?vue&type=template&id=ec455460"
import script from "./InviteListImportSettings.vue?vue&type=script&lang=js"
export * from "./InviteListImportSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports